export enum DigitalizationCheckBotStatus {
  /** Statuses returned by the check bot */
  OK = 'OK',
  CRITICAL = 'Critical',
  ERROR = 'Error',
  WARNING = 'Warning',
  INFO = 'Info',

  /** internally used checkbot statutes */
  TIMED_OUT = 'timed_out',
  WAITING_FOR_METADATA_INSPECTION = 'waiting_for_metadata_inference',
  CHECK_BOT_INSPECTION_DISABLED = 'check_bot_inspection_disabled',
  FAILED = 'failed',
  WAITING = 'waiting',
}
